import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getReviewsAll = createAsyncThunk('getreviewsStatistics',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingReviewDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/viewAllReviews`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(reviewDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(reviewDetailClear())
                message.error(error) 
            })
    }
)




const GetReviewApiSlice = createSlice({
    name: 'Reviewapi',
    initialState: {
        reviewData: null,
        loadingrev: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
        },
    },
    reducers: {
        gettingReviewDetail: state => {
            state.loadingrev=true
            state.reviewData=null
        },
        reviewDetailResponse: (state, action)=>{
            state.reviewData= action.payload
            state.loadingrev= false
        },
        reviewDetailClear: (state)=>{
            state.reviewData= null
            state.loadingrev= false
        },
        changeReviewDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
    },
})
export const { 
    gettingReviewDetail, reviewDetailResponse, reviewDetailClear,
    changeReviewDetailFilters, setPages
} = GetReviewApiSlice.actions;
export default GetReviewApiSlice.reducer;